import Slider from './deps/Slider';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import './Partners.scss';

const Partners: React.FC = () => {
  return (
    <div className="partners" id="partners">
      <div className="container partners__container">
        <ContentFrame title="Partners" className="partners__frame" borders>
          <div className="partners__content">
            <SectionTitle className="partners__title">
              <span>Partners</span>
            </SectionTitle>
            <Slider />
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Partners;
